import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/photo_affaires.jpg'
import _imports_1 from '../assets/img/AFF.jpg'
import _imports_2 from '../assets/img/EPITECH.jpg'
import _imports_3 from '../assets/img/CompTIA.svg'


const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "top",
  class: "lg:h-[80px] h-[50px]"
}, null, -1)
const _hoisted_4 = { class: "max-w-full relative" }
const _hoisted_5 = { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex flex-col justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold md:text-6xl flex opacity-100" }, [
  /*#__PURE__*/_createTextVNode("Iron"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-400" }, "S"),
  /*#__PURE__*/_createTextVNode("ecur,")
], -1)
const _hoisted_7 = { class: "my-[20px] md:text-2xl opacity-100 max-w-[650px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  id: "about",
  class: "h-[10px] w-full"
}, null, -1)
const _hoisted_9 = { class: "container max-w-[1024px] w-full md:my-[40px] duration-200 my-[10px] relative md:h-[500px] h-auto md:flex justify-center items-center p-[10px]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center relative md:pr-[20px] items-center md:w-6/12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "md:max-h-[400px]"
  })
], -1)
const _hoisted_11 = { class: "p-[10px] md:w-6/12 flex flex-col text-left" }
const _hoisted_12 = { class: "my-[20px]" }
const _hoisted_13 = { class: "text-black text-2xl font-semibold uppercase" }
const _hoisted_14 = { class: "text-justify" }
const _hoisted_15 = { class: "py-[20px]" }
const _hoisted_16 = { class: "w-full flex flex-col items-center" }
const _hoisted_17 = { class: "uppercase underline text-2xl font-bold text-center my-[20px]" }
const _hoisted_18 = { class: "w-full md:w-[900px] flex items-center justify-between md:px-[10px] px-0 p-[10px]" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  class: "md:mx-[20px] mx-[10px]",
  id: "scroll-left",
  "aria-label": "Bouton de direction gauche"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-left" })
], -1)
const _hoisted_20 = { class: "parent overflow-x-auto p-[10px] pl-0 flex justify-start items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "md:mx-[20px] mx-[10px]",
  id: "scroll-right",
  "aria-label": "Bouton de direction droite"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right" })
], -1)
const _hoisted_22 = { class: "container max-w-[1024px] relative" }
const _hoisted_23 = { class: "w-full flex flex-col justify-center items-center relative" }
const _hoisted_24 = { class: "uppercase underline text-2xl font-bold text-center my-[20px]" }
const _hoisted_25 = { class: "md:max-w-[calc(100%-100px)] max-w-[calc(100%-20px)] relative" }
const _hoisted_26 = { class: "w-full my-[20px] flex flex-col items-center" }
const _hoisted_27 = { class: "uppercase underline text-2xl font-bold text-center my-[20px]" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"max-w-full md:w-[900px] w-full flex items-center justify-center p-[10px]\"><div class=\"parent flex justify-center items-center\"><a target=\"_blank\" href=\"https://affarmers.com\" class=\"flex md:mx-[20px] mx-[10px] flex-col items-center\"><div class=\"w-[100px] h-[100px] flex justify-center border border-gray-400 items-center rounded-[50%]\"><img src=\"" + _imports_1 + "\" class=\"rounded-[50%]\" alt=\"\"></div><div class=\"mt-[5px]\"><h1>AFF</h1></div></a><a target=\"_blank\" href=\"https://epitech.bj\" class=\"flex md:mx-[20px] mx-[10px] flex-col items-center\"><div class=\"w-[100px] h-[100px] flex justify-center border border-gray-400 items-center relative rounded-[50%]\"><img src=\"" + _imports_2 + "\" class=\"h-[50%] w-[70%]\" alt=\"\"></div><div class=\"mt-[5px]\"><h1>EPITECH</h1></div></a><a target=\"_blank\" href=\"https://www.comptia.org/certifications\" class=\"flex md:mx-[20px] mx-[10px] flex-col items-center\"><div class=\"w-[100px] h-[100px] flex justify-center border border-gray-400 items-center relative rounded-[50%]\"><img src=\"" + _imports_3 + "\" class=\"h-[50%] w-[70%]\" alt=\"\"></div><div class=\"mt-[5px]\"><h1>CompTIA</h1></div></a></div></div>", 1)

import HeaderComponent from '../components/HeaderComponent.vue'
import One_training from '@/components/One_training.vue';
import carouselBranding from '../components/CarouselBranding.vue'
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Carousel from '../components/carousel.vue'
import FooterComponent from '@/components/FooterComponent.vue';
import axiosInstance from '@/plugins/axios';

import axios from 'axios'
const initialSlide = 0;
const pageSize = 6;

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const router = useRouter();
function goToContactPage() {
    router.push('/contacts')
}

const pageTitle = ref('IronSecur'); 

onMounted(() => {
    document.title = pageTitle.value; 
});


const trainings = ref([
  { link: '/training-cybersecurity', image: '/img/training.jpg', title: 'Formation', content: "Formation des développeurs à de meilleures pratiques et enseignement du piratage éthique aux étudiants." },
  
  { link: '/services#servicesList', image: '/img/service2.jpg', title: 'Définition des exigences de sécurité', content: "Identifier les exigences de sécurité nécessaires pour votre application." },
  
  { link: '/services#servicesList', image: '/img/training2.jpg', title: 'Threat Modeling (Modélisation de la menace)', content: "Identifier et quantifier les risques associés à votre application web/mobile ou desktop." },
  
  { link: '/services#servicesList', image: '/img/Audit.jpg', title: 'Audit du code source de l’application', content: "Analyse approfondie du code source de votre application pour identifier les problèmes potentiels." },
  
  { link: '/services#servicesList', image: '/img/Illustration.png', title: 'Création des cas de test de sécurité', content: "Création de scénarios de test pour évaluer la robustesse de votre application face aux menaces potentielles" },
  
  { link: '/services#servicesList', image: '/img/foot.jpg', title: 'Footprinting (énumération) des vulnérabilités potentielles des conteneurs', content: "Identifier les vulnérabilités potentielles dans les conteneurs utilisés par votre application,comme Docker et Vagrant,etc." },
  
  { link: '/services#servicesList', image: '/img/analyse.jpg', title: 'Analyse dynamique de la sécurité de l’application (DAST)', content: "Analyse dynamique de la sécurité de votre application pendant son exécution." },
  
  { link: '/services#servicesList', image: '/img/mise.jpg', title: 'Mise en place et configuration des outils de sécurité applicatifs', content: "Pare-feu ● WAF ● DAST/IAST/SAST,etc." },
  
  { link: '/services#servicesList', image: '/img/test.png', title: 'Tests d\'intrusion', content: "Évaluation de la résilience de vos applications web, mobiles et desktop face aux attaques." },
  
  { link: '/services#servicesList', image: '/img/gestion.jpg', title: 'Gestion des vulnérabilités', content: "Gestion des vulnérabilités que vous pourriez rencontrer afin de les anticiper et les prévenir." },
  
  { link: '/services#servicesList', image: '/img/surveillance.jpg', title: 'Surveillance des systèmes d\'information', content: "Mise en place des alertes en temps réel pour réagir rapidement à toute anomalie." },
  
  { link: '/services#servicesList', image: '/img/audit.avif', title: 'Audit de maturité cybernétique', content: "Évaluation des procédures de votre entreprise, le niveau de sécurité de vos infrastructures logicielles et déterminons votre niveau de maturité actuel." },
]);


const card = ref<any[]>([]);
const filteredArticles = ref<any[]>([]);

onMounted(async () => {
    document.title = pageTitle.value;
    await fetchArticles();
});

const fetchArticles = async () => {
    try {
        const response = await axiosInstance.get('/articles/');
        if (response.status === 200) {
            // Filtrer les articles avec is_published à true dès la première requête
            const articles = response.data.results.filter(article => article.is_published);
            card.value = articles;
            filteredArticles.value = articles;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
    }
};

const loadArticles = async (page: number) => {
    try {
        const response = await axiosInstance.get(`/articles/?page=${page}&page_size=${pageSize}`);

        if (response.status === 200) {
            const { results, previous, next } = response.data;
            // Filtrer les articles avec is_published à true lors du chargement des pages suivantes
            const publishedArticles = results.filter(article => article.is_published);
            filteredArticles.value = publishedArticles;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
    }
};

const currentPage = ref(1);
const hasPreviousPage = ref(false);
const hasNextPage = ref(false);

onMounted(() => {
    loadArticles(currentPage.value);
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(carouselBranding, { "initial-slide": initialSlide })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('branding')), 1)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t('who')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('about_text')), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToContactPage())),
            class: "py-[5px] px-[10px] bg-cyan-500 capitalize text-white rounded-[5px]"
          }, _toDisplayString(_ctx.$t('contact_us')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t('name_service')), 1),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(One_training, { trainings: trainings.value }, null, 8, ["trainings"])
        ]),
        _hoisted_21
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t('name_article')), 1),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(Carousel, { cards: filteredArticles.value }, null, 8, ["cards"])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t('name_partners')), 1),
        _hoisted_28
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})